import * as Init from '../init.js';
import {
    CLAPI
} from '../clchart/cl.api.js'
import * as DATAS from '../datas/transdata.js'
import * as KBAR from './kbar_e.res.js'

// 浮动窗口永远只能有一个存在 无论是菜单还是其他
function showFwindow(chart, result) {
    const nowLR = DATAS.getfloatLR(result.rect, result.mousePos.x)
    const frect = {
        left: nowLR === 'right' ? result.rect.left : result.rect.left + result.rect.width - 230,
        top: result.rect.top,
        width: 115 * Init.scale,
        height: 210 * Init.scale,
    }
    chart.initFwindow('finfo', frect)
    const fwinLayoutCfg = {
        layout: CLAPI.ChartRes.CHART_LAYOUT,
        config: CLAPI.Utils.mergeObjectOfDeep(KBAR.CHART_KBAR_FWIN, CLAPI.ChartRes.CHART_BOARD),
        rectMain: frect
    }
    chart.openFwindow('kbar.fwin', 'system.board', fwinLayoutCfg, function (result) {
        //  console.log(result)
    })
    

    chart.setFwindow('kbar.fwin', KBAR.curdateToFwin(result.data))
    
}

function changeFbar(curKey, curDate) {
    if (Init.getUserInfo('Fbar', 'linkage') === 'lock') {
        return
    }
    Init.sendCommand({
            cmds: {
                "ftrend": {
                    "cmd": "get",
                    "subject": curKey + ".db_params",
                    "service": "factors/ftrend/ready",
                    "info": {
                        "sub-date": curDate,
                        "fields": KBAR.ftrend_fields
                    }
                },
                "ioarea": {
                    "cmd": "get",
                    "subject": curKey + ".db_ioarea",
                    "service": "factors/ftrend/ready",
                    "info": {
                        "sub-date": curDate,
                        "fields": KBAR.ioarea_fields
                    }
                },
            }
        },
        function reply(datas) {
            if (Init.checkDatas(datas)) {
                const curChart = Init.getSysChart()
                const chart = curChart.getChart('Fbar')

                const axisXinfo = DATAS.TrendToAxisXinfo(datas['ftrend'], 'msecstamp')
                // 设置坐标显示信息
                chart.setAxisXinfo(axisXinfo)

                let ioareas = KBAR.ioareaToKV(datas['ioarea'])
                chart.setData('IOAREA', ioareas)

                let ftrends = KBAR.TrendGetKV(datas['ftrend'])
                chart.setData('FTREND', ftrends)

                chart.onPaint()
            }
        });

}


function setKbar(curChart, inData, region) {
    const chartName = 'Kbar'
    const chart = curChart.getChart(chartName)

    chart.setlinkInfo('curKey', Init.getcurKey())

    const keyInfo = DATAS.AinfoToKeyInfo(inData['minfo'])
    chart.setKeyInfo(keyInfo)

    const axisXinfo = DATAS.AdateToAxisXinfo(inData['iobar'], 'msec')
    // 设置坐标显示信息
    chart.setAxisXinfo(axisXinfo)

    let kbars = KBAR.IodateToAvgKbar(inData['iobar'], chart.getKeyInfo(Init.getcurKey()))
    let mainDataName = 'KBAR'
    chart.setData(mainDataName, kbars)

    let bigms = KBAR.IodateToDDTJ(inData['iobar'], axisXinfo)
    chart.setData('BIGM', bigms)

    const mainRect = CLAPI.getChartRect(region, 2, 3, 0, 0)

    // 设置界面信息和绑定数据
    const mainLayoutCfg = {
        layout: {
            offset: {
                top: 5,
                bottom: 5,
                left: 5,
                right: 10
            }
        },
        config: CLAPI.Utils.mergeObjectOfDeep({
                title: {
                    label: keyInfo[Init.getcurKey()].static.name,
                },
            },
            KBAR.CHART_KBAR_AREA),

        rectMain: mainRect

    }
    const maarea = Init.getUserInfo(chartName, 'maarea')
    if (maarea === 'area') {
        mainLayoutCfg.config.lines = KBAR.kbar_main_area_lines
    } 
    else if (maarea === 'grade') {
        mainLayoutCfg.config.lines = KBAR.kbar_main_grade_lines
    } else {
        mainLayoutCfg.config.lines = KBAR.kbar_main_emap_lines
    }
    CLAPI.ChartRes.setButtonValue(mainLayoutCfg.config, 'maarea', maarea)
    
    const exright = Init.getUserInfo(chartName, 'exright')
    if (exright !== 'none') {
        let rights = KBAR.KbarExright(kbars, chart.getKeyInfo(Init.getcurKey()), exright)
        mainDataName = 'KBAR.' + exright
        chart.setData(mainDataName, rights)
    }
    CLAPI.ChartRes.setButtonValue(mainLayoutCfg.config, 'exright', Init.getUserInfo(chartName, 'exright'))
    CLAPI.ChartRes.setButtonValue(mainLayoutCfg.config, 'chip', Init.getUserInfo(chartName, 'chip'))

    // kbar_main_area_lines
    // kbar_main_emap_lines
    // 设置 DAY 为该表的数据源
    // 其他为辅助数据 实际运算时
    const mainchart = chart.createChart('user.kbar', 'system.chart', mainLayoutCfg, function (result) {
        // 这里应该返回交互信息 比如按钮按下 光标位置等
        // console.log('KBAR', result)
        if (result.event === 'mousestop') {
            // console.log('mousemove', result)
            // let curdate = result.data[0]
            if (result.data !== undefined) {
                changeFbar(Init.getcurKey(), result.data[0])
            }
        }
        if (result.event === 'mousemove') {
            showFwindow(chart, result)
        }
        if (result.event === 'mouseout') {
            chart.stopFwindow()
        }
        if (result.event === 'keydown') {

        }
        if (result.event === 'btndown') {
            // console.log('KBAR', result)
            if (result.name === 'maarea') {
                if (Init.getUserInfo(chartName, result.name) !== result.info) {
                    if (result.info === 'area') {
                        mainchart.changeCfg({
                            lines: KBAR.kbar_main_area_lines
                        })
                    } else if (result.info === 'grade') {
                        mainchart.changeCfg({
                            lines: KBAR.kbar_main_grade_lines
                        })
                    } else {
                        mainchart.changeCfg({
                            lines: KBAR.kbar_main_emap_lines
                        })
                    }
                    // mainchart.onPaint()
                    Init.setUserInfo(chartName, result.name, result.info)
                }
            }
            if (result.name === 'chip') {
                if (Init.getUserInfo(chartName, 'chip') !== result.info) {
                    if (result.info === 'chip') {

                    } else {

                    }
                    Init.setUserInfo(chartName, 'chip', result.info)
                }
            }
            if (result.name === 'exright') {
                if (Init.getUserInfo(chartName, result.name) !== result.info) {
                    if (result.info === 'none') {
                        mainDataName = 'KBAR'
                    } else {
                        mainDataName = 'KBAR.' + result.info
                        if (!chart.findData(mainDataName)) {
                            let rights = KBAR.KbarExright(kbars, chart.getKeyInfo(Init.getcurKey()), result.info)
                            chart.setData(mainDataName, rights)
                        }
                        // console.log(dataname, rights);
                    }
                    chart.bindData(mainchart, mainDataName)
                    chart.bindData(volumechart, mainDataName)
                    chart.onPaint()
                    Init.setUserInfo(chartName, result.name, result.info)
                }
                // getKeyInfo
            }
        }
        if (result.event === 'changeAxisY') {
            console.log('KBAR', result)
            const axisYdata = CLAPI.Utils.copyJsonOfDeep(result.axisYdata)
            const areachart = curChart.getUserChart('Fbar', 'user.area')
            if (areachart) {
                areachart.changeAxisY(axisYdata)
            }
        }
    })
    chart.bindData(mainchart, mainDataName)

    const volumeLoyoutCfg = {
        layout: {
            offset: {
                top: 5,
                bottom: 5,
                left: 5,
                right: 10
            }
        },
        config: CLAPI.Utils.mergeObjectOfDeep({
                axisX: {
                    display: 'none',
                },
            },
            CLAPI.ChartRes.CHART_KBAR_SECOND),
        rectMain: CLAPI.getChartRect(region, 2, 3, 0, 1)
    }
    const volumechart = chart.createChart('user.vbar', 'system.chart', volumeLoyoutCfg, function (result) {
        // console.log('VBAR', result)
    })
    chart.bindData(volumechart, mainDataName)

    const analyLayoutCfg = {
        layout: {
            offset: {
                top: 5,
                bottom: 5,
                left: 5,
                right: 10
            }
        },
        // config: CLAPI.Utils.mergeObjectOfDeep({},
        //     KBAR.CHART_KBAR_DDHJ),
        rectMain: CLAPI.getChartRect(region, 2, 3, 0, 2)
    }
    const analy = Init.getUserInfo(chartName, 'analy')
    switch (analy) {
        case 'ddhj':
            analyLayoutCfg.config = CLAPI.Utils.mergeObjectOfDeep({
                    title: {
                        label: '大单合计'
                    },
                    lines: KBAR.kbar_analy_ddhj_lines
                },
                KBAR.CHART_KBAR_DDHJ)
            break;
        case 'ddzb':
        default:
            analyLayoutCfg.config = CLAPI.Utils.mergeObjectOfDeep({
                    title: {
                        label: '大单占比'
                    },
                    lines: KBAR.kbar_analy_ddzb_lines
                },
                KBAR.CHART_KBAR_DDZB)
            break;
    }
    // console.log(analyLayoutCfg.config);
    CLAPI.ChartRes.setButtonValue(analyLayoutCfg.config, 'analy', analy)

    const analychart = chart.createChart('user.line', 'system.chart', analyLayoutCfg, function (result) {
        if (result.event === 'btndown') {
            // console.log('KBAR', result)
            if (result.name === 'analy') {
                if (Init.getUserInfo(chartName, 'analy') !== result.info) {
                    switch (result.info) {
                        case 'ddhj':
                            analychart.changeCfg({
                                title: {
                                    label: '大单合计'
                                },
                                axisY : KBAR.CHART_KBAR_DDHJ.axisY,
                                lines: KBAR.kbar_analy_ddhj_lines
                            })
                            break;
                        case 'ddzb':
                        default:
                            analychart.changeCfg({
                                title: {
                                    label: '大单占比'
                                },
                                axisY : KBAR.CHART_KBAR_DDZB.axisY,
                                lines: KBAR.kbar_analy_ddzb_lines
                            })
                            break;
                    }
                    // analychart.onPaint()
                    Init.setUserInfo(chartName, 'analy', result.info)
                }
            }
        }
    })
    chart.bindData(analychart, 'BIGM')

}

function setFbar(curChart, inData, region) {
    const chartName = 'Fbar'
    const chart = curChart.getChart(chartName)

    chart.setlinkInfo('curKey', Init.getcurKey())

    const keyInfo = DATAS.AinfoToKeyInfo(inData['minfo'])
    chart.setKeyInfo(keyInfo)

    const axisXinfo = DATAS.TrendToAxisXinfo(inData['ftrend'], 'msecstamp')
    // 设置坐标显示信息
    chart.setAxisXinfo(axisXinfo)

    let ioareas = KBAR.ioareaToKV(inData['ioarea'])
    chart.setData('IOAREA', ioareas)

    let ftrends = KBAR.TrendGetKV(inData['ftrend'])
    chart.setData('FTREND', ftrends)

    const mainRect = CLAPI.getChartRect(region, 2, 3, 0, 0)
    const areaHeight = mainRect.height

    const boardRect = CLAPI.getChartRect(region, 2, 1, 1, 0)


    let areaLayoutCfg = {
        layout: {
            offset: {
                top: 5,
                bottom: 5,
                left: 5,
                right: 10
            }
        },
        config: CLAPI.ChartRes.CHART_HORBAR,
        rectMain: {
            left: boardRect.left,
            top: boardRect.top,
            width: boardRect.width,
            height: areaHeight
        }
    }
    CLAPI.ChartRes.setButtonValue(areaLayoutCfg.config, 'locked', Init.getUserInfo('Fbar', 'linkage'))

    const areachart = chart.createChart('user.area', 'system.vline', areaLayoutCfg, function (result) {
        Init.setUserInfo(chartName, 'linkage', result.info)
        // console.log(result)
    })
    chart.bindData(areachart, 'IOAREA')


    const moodHeight = (boardRect.height - areaHeight) / 3
    const moodLayoutCfg = {
        layout: CLAPI.ChartRes.CHART_LAYOUT,
        config: KBAR.CHART_KBAR_MOOD,
        rectMain: {
            left: boardRect.left,
            top: boardRect.top + areaHeight,
            width: boardRect.width,
            height: moodHeight
        }
    }
    const moodchart = chart.createChart('user.mood', 'system.fixed', moodLayoutCfg, function (result) {
        //  console.log(result)
    })
    chart.bindData(moodchart, 'FTREND')

    const wishLayoutCfg = {
        layout: CLAPI.ChartRes.CHART_LAYOUT,
        config: KBAR.CHART_KBAR_EMV,
        rectMain: {
            left: boardRect.left,
            top: boardRect.top + areaHeight + moodHeight,
            width: boardRect.width,
            height: moodHeight
        }
    }
    const wishchart = chart.createChart('user.emv', 'system.fixed', wishLayoutCfg, function (result) {
        //  console.log(result)
    })
    chart.bindData(wishchart, 'FTREND')

    const emvLayoutCfg = {
        layout: CLAPI.ChartRes.CHART_LAYOUT,
        config: KBAR.CHART_KBAR_WISH,
        rectMain: {
            left: boardRect.left,
            top: boardRect.top + areaHeight + 2 * moodHeight,
            width: boardRect.width,
            height: moodHeight
        }
    }
    const emvchart = chart.createChart('user.wish', 'system.fixed', emvLayoutCfg, function (result) {
        //  console.log(result)
    })
    chart.bindData(emvchart, 'FTREND')
}
// 画日线
function drawKbar(inData) {

    console.log('Draw ====> Kbar Line')
    // console.log(JSON.stringify(inData));
    console.log(inData);

    const curChart = Init.getSysChart()
    // 设置为单一窗口 并返回第一个窗口
    curChart.initChart(['Kbar', 'Fbar'])

    const canvas = Init.canvas
    // 设置第一个窗口
    setKbar(curChart, inData, {
        style:  'splitly',
        top:    0,
        left:   0,
        width:  canvas.width,
        height: canvas.height,
    })
    // 设置第二个窗口, 
    setFbar(curChart, inData, {
        style:  'splitly',
        top:    0,
        left:   0,
        width:  canvas.width,
        height: canvas.height,
    })


    curChart.onPaint()
}

export function onLoad() {
    function onLoadData(curKey, inData) {
        // const curDate = CLAPI.Utils.getMsecDate(inData['info'].datas[0][0]);
        const lastDate = CLAPI.Utils.getMsecDate(inData['info'].datas.at(-1)[0]);
        Init.sendCommand({
                cmds: {
                    "ftrend": {
                        "cmd": "get",
                        "subject": curKey + ".db_params",
                        "service": "factors/ftrend/ready",
                        "info": {
                            "sub-date": lastDate,
                            "fields": KBAR.ftrend_fields
                        }
                    },
                    "ioarea": {
                        "cmd": "get",
                        "subject": curKey + ".db_ioarea",
                        "service": "factors/ftrend/ready",
                        "info": {
                            "sub-date": lastDate,
                            "fields": KBAR.ioarea_fields
                        }
                    },
                    "iobar": {
                        "cmd": "get",
                        "subject": curKey + ".inout_date",
                        "service": "merge/aiodb",
                        "info": {
                            "offset": 0,
                            "fields": KBAR.iodate_fields
                        }
                    },
                    "minfo": {
                        "cmd": "get",
                        "subject": curKey + ".alpha_info",
                        "service": "merge/ainfo",
                        "info": {
                            "offset": 0
                        }
                    },
                    // "kbar" : { "cmd" : "get", "subject" : curKey + ".alpha_date", "service": "merge/ainfo", "info" : {"offset" : 0}}
                }
            },
            function reply(datas) {
                if (Init.checkDatas(datas)) {
                    drawKbar(datas)
                }
            });
    }
    let curKey = Init.getcurKey()
    Init.sendCommand({
            cmds: {
                "info": {
                    "cmd": "get",
                    "subject": curKey + ".alpha_info",
                    "service": "merge/ainfo",
                    "info": {
                        "offset": -1
                    }
                }
            }
        },
        function reply(datas) {
            console.log(datas)
            if (Init.checkDatas(datas)) {
                Init.setcurKey(curKey);
                onLoadData(curKey, datas)
            }
        });
}

// 注册方法到参数表